import type { ServicedeskPortalId } from './types.tsx';

export const FETCH_SERVICEDESK_PORTAL = 'state.FETCH_SERVICEDESK_PORTAL' as const;

export const FETCH_SERVICEDESK_PORTAL_SUCCESS = 'state.FETCH_SERVICEDESK_PORTAL_SUCCESS' as const;

type FetchServicedeskPortalPayload = {
	projectId: number;
};

type ServicedeskPortalSuccessPayload = {
	portalId: ServicedeskPortalId;
};

export type FetchServicedeskPortalAction = {
	type: typeof FETCH_SERVICEDESK_PORTAL;
	payload: FetchServicedeskPortalPayload;
};

export const fetchServicedeskPortalAction = (projectId: number): FetchServicedeskPortalAction => ({
	type: FETCH_SERVICEDESK_PORTAL,
	payload: { projectId },
});

export type FetchServicedeskPortalSuccessAction = {
	type: typeof FETCH_SERVICEDESK_PORTAL_SUCCESS;
	payload: ServicedeskPortalSuccessPayload;
};

export const fetchServicedeskPortalSuccessAction = (portalId: ServicedeskPortalId) => ({
	type: FETCH_SERVICEDESK_PORTAL_SUCCESS,
	payload: { portalId },
});

export type Action = FetchServicedeskPortalAction | FetchServicedeskPortalSuccessAction;
